import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 6.063c-3.145 0-5.687 2.57-5.687 5.687v1.094c0 .383-.301.656-.657.656A.63.63 0 0 1 5 12.844V11.75c0-3.855 3.117-7 7-7 3.855 0 7 3.145 7 7v3.965c0 1.312-1.094 2.406-2.434 2.406l-3.007-.027c-.22.41-.657.656-1.121.656h-.876a1.296 1.296 0 0 1-1.312-1.312c0-.711.574-1.313 1.313-1.313h.874c.465 0 .903.273 1.122.656l3.035.028c.601 0 1.093-.493 1.093-1.094V11.75c0-3.117-2.57-5.687-5.687-5.687m-3.062 4.375h.437a.9.9 0 0 1 .875.874v3.063c0 .492-.41.875-.875.875h-.437c-.985 0-1.75-.766-1.75-1.75v-1.312c0-.958.765-1.75 1.75-1.75m6.124 0c.958 0 1.75.792 1.75 1.75V13.5c0 .984-.793 1.75-1.75 1.75h-.437a.864.864 0 0 1-.875-.875v-3.062c0-.465.383-.876.875-.876z"
    }, null, -1)
  ]))]))
}
export default { render: render }